import { render, staticRenderFns } from "./DataLayer.vue?vue&type=template&id=3b16c7fd&scoped=true"
import script from "./DataLayer.vue?vue&type=script&lang=js"
export * from "./DataLayer.vue?vue&type=script&lang=js"
import style0 from "./DataLayer.vue?vue&type=style&index=0&id=3b16c7fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16c7fd",
  null
  
)

export default component.exports